import React from 'react';
import * as moment from 'moment';
import { Link } from 'react-router-dom';


const Truncate = ({ text, maxLength }) =>
  text === null || maxLength >= text.length ? text : `${text.substr(0, text.indexOf(' ', maxLength))}...`;

const ArticleLink = ({ article, className, children }) => <Link className={className} to={`/${article.slug}---${article.id}`}>{children}</Link>;

class Article extends React.Component {

  render() {
    const maxExcerptLength = 396;
    const { article } = this.props;
    const credits =
            `${moment(article.date).format('LLLL')} by ${article.authorName}`;
    const readMore = ' READ MORE >>';

    return (
      <article className="blog-post">
        <div className="post-image-container">
          <ArticleLink article={article} className="post-image">
            <img
              alt=""
              className="img-responsive"
              src={article.imageUrl}
            />
          </ArticleLink>
        </div>
        <div className="post-data">
          <div className="post-data-info">
            <span className="post-creds">{credits}</span>
            <ArticleLink article={article} className="h2 text-primary">{article.title}</ArticleLink>
            <p>
              <Truncate maxLength={maxExcerptLength} text={article.preview} />
              <ArticleLink article={article} className="read-more">{readMore}</ArticleLink>
            </p>
          </div>
        </div>
      </article>
    );
  }
}

export default Article;
